import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/dashboard.vue')
    },
    {
      path: '/page',
      name: 'home',
      component: () => import('./views/dashboard.vue')
    },
    {
      name: 'home',
      path: '/page/home',
      component: () => import('./views/dashboard.vue')
    },
    {
      name: 'non-invasive',
      path: '/page/non-invasive',
      component: () => import('./views/no-embed/index.vue')
    },
    {
      name: 'invasive',
      path: '/page/invasive',
      component: () => import('./views/embed.vue')
    },
    {
      name: 'contact',
      path: '/page/contact',
      component: () => import('./views/contact.vue')
    },
    {
      name: 'interaction',
      path: '/page/interaction',
      component: () => import('./views/bci-interact.vue')
    },
    {
      name: 'welfare',
      path: '/page/welfare',
      component: () => import('./views/bci-welfare.vue')
    },
    {
      name: 'forward-looking',
      path: '/page/forward-looking',
      component: () => import('./views/bci-front.vue')
    }
  ],
  scrollBehavior (to, from) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    return { x: 0, y: 0 }
  }
})
